import Image from 'next/image';
import Link from 'next/link';
import styled from 'styled-components';

const StyledArticleCard = styled.div`
  min-height: 200px;
  width: 100%;
  border-radius: 15px;
  cursor: pointer;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.05);
  padding: 0.75em;
  display: grid;

  @media screen and (min-width: 768px) {
    min-height: 280px;
    width: 100%;
  }

  .cover-image {
    display: flex;
    width: 100%;
    height: 50%;
    overflow: hidden;
    position: relative;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    .img {
      position: absolute;
      object-fit: cover;
      width: 100%;
      height: unset;
    }
  }

  .card-details {
    height: 50%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .title {
      font-weight: 600;
      font-size: 1.8rem;
    }

    span {
      font-size: 1.3rem;
    }

    .detail {
      color: black;
    }
  }
`;

export const ArticleCard = ({ article }) => {
  return (
    <StyledArticleCard>
      <Link href={`/blog/${article.slug?.current}`}>
        <a>
          <div className="cover-image">
            <Image src={article.coverImage?.asset?.url} layout="fill" className="img" alt="" />
          </div>
          <div className="card-details">
            <h2 className="title">{article.title}</h2>

            <div>
              {article.categories && <span className="detail">{article.categories[0]?.title}</span>}
            </div>
          </div>
        </a>
      </Link>
    </StyledArticleCard>
  );
};
